import React, { useContext } from 'react'
import CompetencePicker from 'Components/reusable/InputFields/CompetencePicker'
import { ICompetence } from 'types/cvsInterfaces'
import { CompetenceId } from 'types/ids'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Person picker.
 */
export const DataEditContextCompetenceField = <T extends AnyObject>({
  field,
  dataField,
  usedCompetences,
  submitOnEnter,
  icon,
  placeholder,
  hideLabel,
  options,
  insetLabel,
  resetOnSelect,
  ...rest
}: {
  field: EditableFieldsOfType<T, CompetenceId | null>
  dataField: EditableFieldsOfType<T, ICompetence | null>
  usedCompetences?: ICompetence[]
  submitOnEnter?: boolean
  icon?: React.ReactElement
  placeholder?: string
  hideLabel?: boolean
  options?: ICompetence[]
  insetLabel?: boolean
  resetOnSelect?: boolean
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, disabled, setFields, localeBase, t, handleSubmit } = useContext<ContextValue<T>>(Context)

  const handleChange = (newValue: ICompetence | null) => {
    setFields({ [field]: newValue?.id ?? null, [dataField]: newValue })
  }

  const dataValue = flatData[dataField] as unknown as ICompetence

  return (
    <CompetencePicker
      onChange={handleChange}
      icon={icon}
      disabled={disabled[field]}
      value={dataValue ?? null}
      label={t(`${localeBase}.${field}`)}
      usedCompetences={usedCompetences}
      onKeyDown={e => submitOnEnter && handleSubmit(e)}
      placeholderText={placeholder}
      placeholderLabel={hideLabel ? placeholder : undefined}
      options={options}
      insetLabel={insetLabel}
      resetOnSelect={resetOnSelect}
      {...rest}
    />
  )
}

/**
 * Color picker.
 */
